import { AxiosResponse } from "axios";
import apiRequest from "../../utils/apiUtils/apiRequest";

export function getPartnerCertifications(account: string, howMany: number) {
    const url = "/resources/Certifications/account/" + account + "?howMany=" + howMany;
    return apiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });
}





